var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stamp",style:(("padding: " + _vm.stampPadding))},[_c('v-icon',{attrs:{"size":"18","color":"success500"}},[_vm._v("$yzi-check")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }